import {
    DependentIds,
    EntityType,
    VisibilityConflictsOnMove,
} from "features/qualityForm/qualityFormSlice";
import { ErrorAction } from "./VisibilityConflictErrorBox";
import { DeletionVisibilityConflictErrorBox } from "./VisibilityConflictErrorBoxForDeletion";
import { MovingVisibilityConflictErrorBox } from "./VisibilityConflictErrorBoxForMoving";

// TODO : we may wonna update the fonts for the error messages
export function VisibilityConflictErrorBoxContainer({
    visibilityDependentIds,
    visibilityConflictsOnMove,
    clearVisibilityConflicts,
    entityType,
    errorAction,
    children,
}: {
    visibilityDependentIds?: DependentIds;
    visibilityConflictsOnMove?: VisibilityConflictsOnMove;
    clearVisibilityConflicts: () => void;
    entityType: EntityType;
    errorAction: ErrorAction;
    children: JSX.Element;
}) {
    return (
        <>
            {visibilityDependentIds && errorAction === ErrorAction.Delete && (
                <DeletionVisibilityConflictErrorBox
                    conflictingIds={visibilityDependentIds}
                    entityType={entityType}
                    clearVisibilityConflicts={() => clearVisibilityConflicts()}
                />
            )}
            {visibilityConflictsOnMove &&
                errorAction !== ErrorAction.Delete && (
                    <MovingVisibilityConflictErrorBox
                        visibilityConflictsOnMove={visibilityConflictsOnMove}
                        entityType={entityType}
                        userErrorAction={errorAction}
                        clearVisibilityConflicts={() =>
                            clearVisibilityConflicts()
                        }
                    />
                )}
            {children}
        </>
    );
}
